import {apiKeys} from "./Utils/Utils.js";

import IntersectionObserverAnimations from './Components/IntersectionObserverAnimations';
import LocalContacts from './Components/LocalContacts';
import Newsroom from './Components/Newsroom';
import MediaLibrary from './Components/MediaLibrary';

import WPCoreCoverVideo from './Components/WPCoreCoverVideo';
import WPBlockMediaTextVideo from "./Components/WPBlockMediaTextVideo";
import WPBlockVideo from "./Components/WPBlockVideo";
import WPBlockYoutubeEmbed from "./Components/WPBlockYoutubeEmbed";
import GoogleMap from './Components/GoogleMap';
import PeopleSlideshow from "./Components/PeopleSlideshow";
import Menu1 from "./Components/Menu1";
import MenuWorldwide from "./Components/MenuWorldwide";
import MenuOverlayToggler from "./Components/MenuOverlayToggler";
//import ScrollHandler from "./Components/ScrollHandler";

// ACF Blocks
import Counters from './Components/acf-blocks/Counters.js';
import LatestNews from './Components/acf-blocks/LatestNews.js';


/*! modernizr 3.6.0 (Custom Build) | MIT *
 * https://modernizr.com/download/?-setclasses !*/
!function(n,e,s){function o(n,e){return typeof n===e}function a(){var n,e,s,a,i,l,r;for(var c in f)if(f.hasOwnProperty(c)){if(n=[],e=f[c],e.name&&(n.push(e.name.toLowerCase()),e.options&&e.options.aliases&&e.options.aliases.length))for(s=0;s<e.options.aliases.length;s++)n.push(e.options.aliases[s].toLowerCase());for(a=o(e.fn,"function")?e.fn():e.fn,i=0;i<n.length;i++)l=n[i],r=l.split("."),1===r.length?Modernizr[r[0]]=a:(!Modernizr[r[0]]||Modernizr[r[0]]instanceof Boolean||(Modernizr[r[0]]=new Boolean(Modernizr[r[0]])),Modernizr[r[0]][r[1]]=a),t.push((a?"":"no-")+r.join("-"))}}function i(n){var e=r.className,s=Modernizr._config.classPrefix||"";if(c&&(e=e.baseVal),Modernizr._config.enableJSClass){var o=new RegExp("(^|\\s)"+s+"no-js(\\s|$)");e=e.replace(o,"$1"+s+"js$2")}Modernizr._config.enableClasses&&(e+=" "+s+n.join(" "+s),c?r.className.baseVal=e:r.className=e)}var t=[],f=[],l={_version:"3.6.0",_config:{classPrefix:"",enableClasses:!0,enableJSClass:!0,usePrefixes:!0},_q:[],on:function(n,e){var s=this;setTimeout(function(){e(s[n])},0)},addTest:function(n,e,s){f.push({name:n,fn:e,options:s})},addAsyncTest:function(n){f.push({name:null,fn:n})}},Modernizr=function(){};Modernizr.prototype=l,Modernizr=new Modernizr;var r=e.documentElement,c="svg"===r.nodeName.toLowerCase();a(),i(t),delete l.addTest,delete l.addAsyncTest;for(var u=0;u<Modernizr._q.length;u++)Modernizr._q[u]();n.Modernizr=Modernizr}(window,document);

//
// Manage vh unit
const setAppHeights = () => {
	const vh = window.innerHeight * .01;
	document.documentElement.style.setProperty('--vh', `${vh}px`);
	document.documentElement.style.setProperty('--app-height', `${window.innerHeight}px`);
};
window.addEventListener('resize', setAppHeights)
setAppHeights();

//
// Manage IntersectionObservers
const intersectionObserverIsSupported = (!!window.IntersectionObserver || 'IntersectionObserver' in window);
if(intersectionObserverIsSupported) {
	document.body.classList.add('js-intersection-observer');
	new IntersectionObserverAnimations();
}

//
// Blocks
document.querySelectorAll('.local-contacts').forEach(domEl => new LocalContacts(domEl));
document.querySelectorAll('.newsroom').forEach(domEl => new Newsroom(domEl));
document.querySelectorAll('.media-library').forEach(domEl => new MediaLibrary(domEl));


document.querySelectorAll('.wp-block-cover-wrapper.has-video').forEach(domEl => new WPCoreCoverVideo(domEl));
document.querySelectorAll('.wp-block-media-text-wrapper.has-video').forEach((block) => new WPBlockMediaTextVideo(block));
document.querySelectorAll('.wp-block-embed-youtube').forEach(domEl => new WPBlockYoutubeEmbed(domEl));
document.querySelectorAll('.wp-block-video-wrapper').forEach(domEl => new WPBlockVideo(domEl));
document.querySelectorAll('.svitzer-people .wp-block-columns-wrapper').forEach(domEl => new PeopleSlideshow(domEl));

// ACF Blocks
document.querySelectorAll('.acf-block-counters').forEach(domEl => new Counters(domEl));
document.querySelectorAll('.acf-block-latest-news').forEach(domEl => new LatestNews(domEl));

// Google Maps
const googleMaps = document.querySelectorAll('.svitzer-google-map');
if(googleMaps && googleMaps.length > 0) {

	window.initGoogleMaps = () => {
		googleMaps.forEach(domEl => new GoogleMap(domEl));
	}

	const script = document.createElement('script');
	const apiKey = apiKeys.googleMaps;
	script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&callback=initGoogleMaps`;
	script.async = true;
	document.head.appendChild(script);
}


//
// Menus
new Menu1();
new MenuWorldwide();

new MenuOverlayToggler();
//
// Manage Scroll

/*
new ScrollHandler({
	breakpoint1: 100,
	breakpoint2: 400,
	timeoutDelay: 750,
});
*/
//
// Manage copy to clipboard
const enableCopyToClipboard = () => {
	document.querySelectorAll('button.copy-url-to-clipboard:not(.copy-url-initialized)').forEach((btn) => {
		btn.addEventListener('click', (e) => {
			e.preventDefault();

			let url = btn.getAttribute('data-url')
			if(!url.includes('http')) {
				url = `https://${url}`;
			}

			const el = document.createElement('textarea');
			el.value = url;
			el.setAttribute('readonly', '');
			el.style.position = 'absolute';
			el.style.left = '-9999px';
			document.body.appendChild(el);
			el.select();
			document.execCommand('copy');
			document.body.removeChild(el);


			if(btn.getAttribute('data-tooltip-backup')) {
				btn.setAttribute('data-tooltip', btn.getAttribute('data-tooltip-backup'));
			}
			btn.setAttribute('data-tooltip-backup', btn.getAttribute('data-tooltip'));
			btn.setAttribute('data-tooltip', 'Copied');

			setTimeout(() => {
				btn.setAttribute('data-tooltip', btn.getAttribute('data-tooltip-backup'));
				btn.classList.remove('js-clicked');
			}, 2000);


			btn.classList.add('js-clicked');

		});
	});
}
enableCopyToClipboard();

document.addEventListener('mediaLibraryUpdated', enableCopyToClipboard );

//
// Cookie Compliance
// Footer links
const cookiePrefLinks = document.querySelectorAll('.cookie-preferences a, .cookie-compliance-renew');
if(cookiePrefLinks) {
	cookiePrefLinks.forEach(cookiePrefLink => {
		cookiePrefLink.addEventListener('click', (e) => {
			e.preventDefault();
			if(window.CookieInformation && window.CookieConsent && window.CookieConsent.renew) {
				window.CookieConsent.renew();
			}
			return false;
		});
	})
}
let svitzer21CookieCatStatistic1stLoad = false;

let svitzer21CookieCatMarketing1stLoad = false;


window.addEventListener('CookieInformationConsentGiven', (e) => {
	if(CookieInformation.getConsentGivenFor('cookie_cat_statistic')) {

		const blocksOptoutStatistic = document.querySelectorAll('.cookieconsent-optout-statistic');
		blocksOptoutStatistic.forEach((block) => {
			block.style.display = 'none';
		})
		if(!svitzer21CookieCatStatistic1stLoad) {
			svitzer21CookieCatStatistic1stLoad = true;
		}
	}

	if(CookieInformation.getConsentGivenFor('cookie_cat_marketing')) {
		const blocksOptoutMarketing = document.querySelectorAll('.cookieconsent-optout-marketing');
		blocksOptoutMarketing.forEach((block) => {
			block.style.display = 'none';
		})
		if(!svitzer21CookieCatMarketing1stLoad) {
			svitzer21CookieCatMarketing1stLoad = true;
		}
	}

}, false);